/* Choose Recovery Answers Book - small progressive enhancement.
   Answer pages: tap-to-reveal cards, one open at a time.
   Hub: in-page question finder with chapter chips (card photos are rendered in Liquid).
   No network requests, no cookies, no storage, no tracking. Without JS, every card is open
   and the hub shows its full list. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------- Answer pages ---------- */
  function initCards(root) {
    var cards = root.querySelectorAll('details[data-cr-card]');
    if (!cards.length) return;
    each(cards, function (d) { d.open = false; });
    each(cards, function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        each(cards, function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
    window.addEventListener('beforeprint', function () {
      each(cards, function (d) { d.open = true; });
    });
  }

  /* ---------- Hub finder ---------- */
  function norm(s) {
    s = (s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function initHub(hub) {
    var finder = hub.querySelector('[data-cr-finder]');
    var body = hub.querySelector('.cr-hub-body');
    if (!finder || !body) return;

    var groups = [], items = [], cur = null;
    each(body.children, function (el) {
      if (el.matches('h2.cr-chapter')) {
        cur = { h: el, name: el.textContent.replace(/\s+/g, ' ').trim(), extra: [], cards: [] };
        groups.push(cur);
        return;
      }
      if (!cur || el.tagName === 'SCRIPT') return;
      var href = el.matches('a.cr-hub-card') ? (el.getAttribute('href') || '') : '';
      if (href.indexOf('/blogs/answers/') === 0) {
        var h3 = el.querySelector('h3');
        var it = { el: el, group: cur, text: norm(h3 ? h3.textContent : el.textContent) };
        cur.cards.push(it);
        items.push(it);
      } else {
        cur.extra.push(el);
      }
    });
    if (!items.length) return;

    var input = finder.querySelector('.cr-search');
    var chipsBox = finder.querySelector('[data-cr-chips]');
    var countEl = finder.querySelector('[data-cr-count]');
    var emptyEl = finder.querySelector('[data-cr-empty]');
    var active = null;
    var chips = [];

    function addChip(label, group) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cr-fchip';
      b.textContent = label;
      b.setAttribute('aria-pressed', group === null ? 'true' : 'false');
      b.addEventListener('click', function () {
        active = group;
        each(chips, function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
        apply();
      });
      chips.push(b);
      chipsBox.appendChild(b);
    }
    addChip('All', null);
    groups.forEach(function (g) { if (g.cards.length) addChip(g.name, g); });

    function apply() {
      var q = norm(input.value);
      var words = q ? q.split(' ') : [];
      var filtering = !!(q || active);
      var shown = 0;
      items.forEach(function (it) {
        var ok = (!active || it.group === active) &&
          words.every(function (w) { return it.text.indexOf(w) > -1; });
        it.el.hidden = !ok;
        if (ok) shown++;
      });
      groups.forEach(function (g) {
        var any = g.cards.some(function (it) { return !it.el.hidden; });
        g.h.hidden = filtering && !any;
        g.extra.forEach(function (e) { e.hidden = filtering; });
      });
      emptyEl.hidden = shown > 0;
      countEl.textContent = filtering ? (shown + (shown === 1 ? ' question' : ' questions')) : '';
    }

    input.addEventListener('input', apply);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { input.value = ''; apply(); }
      if (e.key === 'Enter') e.preventDefault();
    });
    finder.hidden = false;
  }

  ready(function () {
    each(document.querySelectorAll('.cr-answer'), initCards);
    each(document.querySelectorAll('[data-cr-hub]'), initHub);
  });
})();
